import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotifications = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M14 20q0 .825-.588 1.412A1.93 1.93 0 0 1 12 22q-.825 0-1.412-.588A1.93 1.93 0 0 1 10 20zM12 2q.624 0 1.063.438.437.436.437 1.062v.7q2 .5 3.25 2.113T18 10v7h2v2H4v-2h2v-7q0-2.074 1.25-3.687T10.5 4.2v-.7q0-.625.438-1.062A1.45 1.45 0 0 1 12 2m0 4q-1.65 0-2.825 1.175T8 10v7h8v-7q0-1.65-1.175-2.825T12 6" })
});
export default SvgNotifications;
